import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('usageReporting');
const type = createActionType('usageReporting');

export const LOAD_WAREHOUSE_USAGE = type('LoadWarehouseUsage');
export const SELECT_WAREHOUSES = type('SelectWarehouses');
export const SET_WAREHOUSE_FILTER = type('SetWarehouseFilter');
export const LOAD_WAREHOUSES = type('LoadWarehouses');

export const DO_LOAD_WAREHOUSE_CUBE = type('LoadWarehouseCube');

export const CHECK_WAREHOUSE_USAGE_TABLE_ACCESS = apiType('CheckWarehouseUsageTableAccess');
export const SET_WAREHOUSE_CUBE_DATE_FILTER = type('SetWarehouseCubeDateFilter');
export const SET_WAREHOUSE_CUBE_WAREHOUSE_FILTER = type('SetWarehouseCubeWarehouseFilter');
export const SET_WAREHOUSE_CUBE_USER_FILTER = type('SetWarehouseCubeUserFilter');
export const SET_WAREHOUSE_CUBE_SECONDARY_DIMENSION = type('SetWarehouseCubeSecondaryDimension');
export const SET_WAREHOUSE_CUBE_PRIMARY_DIMENSION = type('SetWarehouseCubePrimaryDimension');
export const SET_WAREHOUSE_CUBE_MEASURE = type('SetWarehouseCubeMeasure');
export const SET_WAREHOUSE_CUBE_DATE_FILTER_AND_BIN = type('SetWarehouseCubeDateFilterAndBin');
export const RESET_WAREHOUSE_CUBE_FILTERS = type('ResetWarehouseCubeFilters');
export const CREATE_EXPLORE = type('CreateExplore');
export const GET_QUERY_HISTORY_COLUMNS = apiType('GetQueryHistoryColumns');
export const SELECT_TAB = type('SelectTab');

export const SELECT_CHART_AREA = type('SelectChartArea');
export const CHANGE_CHART_TYPE = type('ChangeChartType');
export const GET_USAGE_JOB_DEFINITION = apiType('GetUsageJobDefinition');
export const GET_USAGE_JOB_DEFINITIONS = type('GetUsageJobDefinitions');
